import React from 'react';
import PropTypes from 'prop-types';
import equal from 'fast-deep-equal';
import FilesTile from '../FilesTile/FilesTile';

/**
 * FilesGroup 组件 - 用于展示文件组列表
 * @param {Object} props - 组件属性
 * @param {Object} props.data - 包含文件组数据的对象
 */
const FilesGroup = ({ data }) => {
  console.log(data, 'FilesGroup 组件被渲染了');

  // 解构数据对象，设置默认值防止报错
  const {
    entries = [], // 文件条目数组
    changelogMaps = [], // 更新日志映射数组
    id, // 文件组的唯一标识符
    category_id // 类别ID
  } = data;

  return (
    // 文件组的容器
    <div className="group-container">
      {/* 遍历所有文件条目并渲染 FilesTile 组件 */}
      {entries.map((entry, index) => (
        <FilesTile
          // 使用组合键确保每个子组件的唯一性
          key={`${id}-${entry.id}`}
          // 设置文件标题
          title={entry.name}
          // 传递参数对象
          params={{
            category: category_id === 'handbook' ? 'handbook' : entry.id, // 根据category_id判断是否为手册
            series_id: id, // 系列ID
          }}
          // 传递更新日志映射
          changelogMaps={changelogMaps}
        />
      ))}
    </div>
  );
};

// 使用 PropTypes 定义组件属性的类型，提高代码可靠性
FilesGroup.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    category_id: PropTypes.string,
    entries: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      })
    ),
    changelogMaps: PropTypes.array,
  }).isRequired,
};

// 使用 React.memo 和 deep-equal 优化组件性能
export default React.memo(FilesGroup, equal);
